import VoltNowLogoWhite from 'src/_shared/components/_icons/VoltNowLogoWhite'

const Hero = (): JSX.Element => {
	return (
		<div className="relative h-screen">
			{/* Hero Image */}
			<picture>
				<source media="(max-width: 511px)" srcSet="/assets/voltnow_page/hero/511w_1x.jpg" />
				<source
					media="((min-width: 512px) and (max-width: 1024px))"
					srcSet="/assets/voltnow_page/hero/1024w_1x.jpg"
				/>
				<img
					loading="lazy"
					src="/assets/voltnow_page/hero/1440w_1x.jpg"
					alt="A person charging their EV at a charging station, representing the convenience of VoltNow"
					className="absolute inset-0 h-full w-full object-cover"
				/>
			</picture>
			<div className="relative z-10 flex h-screen flex-col items-center justify-center space-y-5 px-10 text-center text-white md:px-20">
				<VoltNowLogoWhite className="w-48" />
				<div className="font-heading text-heading-3 leading-none tracking-tight lg:text-heading-2">
					Scan. Pay. Charge.
				</div>
				<div className="mb-3 text-paragraph lg:pt-2">Web-Based Card & Online Payments.</div>
			</div>
		</div>
	)
}

export default Hero
